import { DataRequestDto } from '../../../../../../api-main';

export function getScaleTypes(): DataRequestDto.ScaleEnum[] {
  return (Object.keys(DataRequestDto.ScaleEnum) as any) as DataRequestDto.ScaleEnum[];
}
